import { useMutation, useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { prepareCustomerResults, previewPrepareCustomerResultsExport } from 'api/customerResults';
import queryClient from 'utils/queryClient';

export const usePrepareCustomerResultsMutation = () =>
  useMutation(prepareCustomerResults, {
    onError: () => {
      enqueueSnackbar("Error occurred, Prepare Customer Results can't start", { variant: 'error' });
    },
    onSuccess: () => {
      enqueueSnackbar('Start preparing customer results', { variant: 'success' });
      queryClient.invalidateQueries(['jobs']);
    },
  });

type PreviewPrepareCustomerResultsExportParams = Parameters<typeof previewPrepareCustomerResultsExport>[0];

export const usePreviewPrepareCustomerResultsExport = (
  previewCustomerResultsExportParams: PreviewPrepareCustomerResultsExportParams
) =>
  useQuery(['previewCustomerResultsExport', [previewCustomerResultsExportParams]], {
    queryFn: ({ signal }) => previewPrepareCustomerResultsExport(previewCustomerResultsExportParams, signal),
    keepPreviousData: true,
  });
